import React, { useEffect, useState } from "react";
import Alert from "../../utils/Alert";
import Select from "react-select";
import httpClient from "../../http/HttpRequest";
import { CATEGORY_LIST, REGISTER, TRUCK_LIST } from "../../data/url";
import { useLocation, useNavigate } from "react-router-dom";
import { checkToken } from "../../utils/Auth";
import LoginModal from "./LoginModal";
import FrontendLayout from "../FrontendLayout";
import Showdistance from "./Showdistance";
import Helper from "../../utils/Helper";
import { useCustomerContext } from "../../context/CustomerContext";
import QuoteProgress from "./QuoteProgress";

const PRICE_PER_KM = 100;
const TRUCK_CAPACITY_KG = {
  1: 1500,
  2: 3500,
  3: 5000,
  4: 7000,
  5: 6500,
  6: 10000,
  7: 8000,
  8: 15000,
  9: 28000,
  10: 0,
  11: 25000,
  12: 18000,
};
const TRUCK_PRICE_PER_KM = {
  1: 28,
  2: 33,
  3: 36,
  4: 39,
  5: 43,
  6: 50,
  7: 57,
  8: 82,
  9: 100,
  10: 0,
  11: 90,
  12: 88,
};

const Qoute = () => {
  const [truckList, setTruckList] = useState([]);
  const [catList, setCatList] = useState([]);
  const [truckData, setTruckData] = useState([]);
  const navigate = useNavigate();
  const [loginModal, setLoginModal] = useState(false);
  const [distance, setDistance] = useState({});
  const location = useLocation();

  useEffect(() => {
    if (location.state?.distanceDetails) {
      setDistance(location.state.distanceDetails);
    }
  }, [location.state]);

  const [formData, setFormData] = useState({
    selectedTruck: null,
    selectedCategory: null,
    weight: 0,
    weightType: "",
    name: "",
    mobile: "",
    remark: "",
  });

  const [errors, setErrors] = useState({});

  const { updateCustomerData } = useCustomerContext();

  useEffect(() => {
    getTruckList();
    getCatList();
  }, []);

  const handleBack = () => {
    navigate("/newQuote");
  };

  const getTruckList = async () => {
    let payload = {};
    const res = await httpClient.plainRequest(TRUCK_LIST, payload);
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        let data = result.data;
        setTruckData(data);
        let option = [];
        data.forEach((element) => {
          option.push({ label: `${element.truck_name}`, value: element.id });
        });
        setTruckList(option);
      }
    }
  };

  const getCatList = async () => {
    let payload = {};
    const res = await httpClient.plainRequest(CATEGORY_LIST, payload);
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        let data = result.data;
        let option = [];
        data.forEach((element) => {
          option.push({ label: `${element.category_name}`, value: element.id });
        });
        setCatList(option);
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.selectedTruck) {
      newErrors.selectedTruck = "Please select a truck.";
    }

    if (!formData.selectedCategory) {
      newErrors.selectedCategory = "Please select a category.";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Please enter a valid 10-digit mobile number.";
    }

    if (!formData.name.trim()) {
      newErrors.name = "Name is required.";
    }

    if (!formData.weight) {
      newErrors.weight = "Weight is required.";
    }

    if (!formData.weightType.trim()) {
      newErrors.weightType = "Weight Type is required.";
    }

    return newErrors;
  };

  const onTruckChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      selectedTruck: selectedOption,
    }));
    setErrors((prev) => ({ ...prev, selectedTruck: "" }));
  };

  const onCatChange = (selectedOption) => {
    setFormData((prev) => ({
      ...prev,
      selectedCategory: selectedOption,
    }));
    setErrors((prev) => ({ ...prev, selectedCategory: "" }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
    } else {
      const token = checkToken();  
        if (!token) {
          setLoginModal(true);
        }else{
          redirectPayment();
        }
        setErrors({});     
    }
  };

  const customStyle = {
    control: (base) => ({
      ...base,
      minHeight: "58px",
      borderColor: "#e1e3ea",
      borderRadius: "12px",
      boxShadow: "none",
      "&:hover": { borderColor: "#ff3e41" },
    }),
    valueContainer: (base) => ({
      ...base,
      minHeight: "56px",
      padding: "2px 14px",
      display: "flex",
      alignItems: "center",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#8a8d98",
    }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base) => ({ ...base, color: "#ff3e41" }),
    menu: (base) => ({ ...base, zIndex: 20, borderRadius: "12px" }),
  };

  const closeLoginModal = (status, data = {}) => {
    setLoginModal(status);
    if (data.otpVerify !== undefined) {
      register();
    } else if (data.token !== undefined) {
      localStorage.setItem("token", data.token);
      updateCustomerData();
      redirectPayment();
    } else {
      return;
    }
  };

  const register = async () => {
    let post = { name: formData.name, mobile: formData.mobile };
    const res = await httpClient.plainRequest(REGISTER, post);
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        localStorage.setItem("token", result.token);
        updateCustomerData();
        Alert.success(result.message);
        redirectPayment();
      } else {
        Alert.error(result.message);
      }
    }
  };

  const findTruckDetails = () => {
    const truckId = formData.selectedTruck["value"];
    const foundTruck = truckData.find((item) => item.id === truckId);
    if (foundTruck) {
      const distanceMeters = Helper.convertToDecimal(distance.value);
      if (distanceMeters === false) {
        return false;
      }

      const distanceKm = distanceMeters / 1000;
      const pricePerKm = Helper.convertToDecimal(
        foundTruck.price_per_km ??
          TRUCK_PRICE_PER_KM[foundTruck.id] ??
          PRICE_PER_KM
      );
      const weight = Helper.convertToDecimal(formData.weight);
      const capacityKg = Helper.convertToDecimal(
        foundTruck.capacity_kg ?? TRUCK_CAPACITY_KG[foundTruck.id]
      );
      const tax = Helper.convertToDecimal(foundTruck.tax);
      if (
        pricePerKm === false ||
        pricePerKm <= 0 ||
        weight === false ||
        weight <= 0 ||
        capacityKg === false ||
        capacityKg <= 0 ||
        tax === false
      ) {
        return { error: "Pricing is not available for the selected truck." };
      }

      const weightKg = formData.weightType === "TON" ? weight * 1000 : weight;
      if (weightKg > capacityKg) {
        return {
          error: `Entered weight exceeds the selected truck capacity of ${capacityKg} KG.`,
        };
      }

      const amount = distanceKm * pricePerKm;
      const taxAmount = (amount * tax) / 100;

      return {
        amount: Number(amount.toFixed(2)),
        tax: Number(taxAmount.toFixed(2)),
        netamount: Number((amount + taxAmount).toFixed(2)),
      };
    } else {
      return false;
    }
  };

  const redirectPayment = () => {
    const a = findTruckDetails();
    if (a && !a.error) {
      navigate("/payment", {
        state: { distanceDetails: distance, formData: formData, totals: a },
      });
    } else {
      Alert.error(a?.error || "Calculation Error");
    }
  };

  return (
    <FrontendLayout>
      <main className="quote-flow-page">
        <div className="container quote-flow-container">
          <div className="quote-flow-heading wow fadeInUp" data-wow-delay="0.1s">
            <span className="quote-flow-eyebrow">
              <i className="fa fa-truck"></i> Tailored for your shipment
            </span>
            <h1>Tell us about your load</h1>
            <p>
              Choose the right truck and add shipment details for an accurate
              estimate.
            </p>
          </div>
          <QuoteProgress activeStep={2} />
          {Object.keys(distance).length > 0 && (
            <Showdistance distanceDetails={distance} />
          )}

          <section className="quote-surface quote-details-surface wow fadeIn" data-wow-delay="0.2s">
            <div className="quote-surface-header">
              <span className="quote-surface-icon">
                <i className="fa fa-box-open"></i>
              </span>
              <div>
                <span className="quote-surface-kicker">Shipment profile</span>
                <h2>Load and contact details</h2>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="row g-4">
                <div className="col-12 col-lg-6 quote-field">
                  <label>Select truck</label>
                  <Select
                    value={formData.selectedTruck}
                    options={truckList}
                    isSearchable={true}
                    placeholder="Choose a suitable truck"
                    onChange={onTruckChange}
                    styles={customStyle}
                    classNamePrefix="quote-select"
                  />
                  {errors.selectedTruck && (
                    <small className="quote-field-error">{errors.selectedTruck}</small>
                  )}
                </div>

                <div className="col-12 col-lg-6 quote-field">
                  <label>Goods category</label>
                  <Select
                    value={formData.selectedCategory}
                    options={catList}
                    isSearchable={true}
                    placeholder="Choose goods category"
                    onChange={onCatChange}
                    styles={customStyle}
                    classNamePrefix="quote-select"
                  />
                  {errors.selectedCategory && (
                    <small className="quote-field-error">{errors.selectedCategory}</small>
                  )}
                </div>

                <div className="col-12 col-lg-6 quote-field">
                  <label htmlFor="weight">Shipment weight</label>
                  <div className="quote-weight-control">
                    <input
                      type="number"
                      id="weight"
                      className="form-control"
                      name="weight"
                      min="0"
                      step="any"
                      value={formData.weight}
                      onChange={handleChange}
                      placeholder="Enter weight"
                    />
                    <select
                      className="form-select"
                      onChange={handleChange}
                      name="weightType"
                      value={formData.weightType}
                      aria-label="Weight unit"
                    >
                      <option value="">Unit</option>
                      <option value="KG">KG</option>
                      <option value="TON">TON</option>
                    </select>
                  </div>
                  {errors.weight && (
                    <small className="quote-field-error">{errors.weight}</small>
                  )}
                  {errors.weightType && (
                    <small className="quote-field-error">{errors.weightType}</small>
                  )}
                </div>

                <div className="col-12 col-lg-6 quote-field">
                  <label htmlFor="name">Contact name</label>
                  <div className="quote-input-shell">
                    <i className="fa fa-user quote-input-icon"></i>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter your full name"
                    />
                  </div>
                  {errors.name && (
                    <small className="quote-field-error">{errors.name}</small>
                  )}
                </div>

                <div className="col-12 col-lg-6 quote-field">
                  <label htmlFor="mobile">Mobile number</label>
                  <div className="quote-input-shell">
                    <i className="fa fa-phone-alt quote-input-icon"></i>
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Enter 10-digit mobile number"
                    />
                  </div>
                  {errors.mobile && (
                    <small className="quote-field-error">{errors.mobile}</small>
                  )}
                </div>

                <div className="col-12 col-lg-6 quote-field">
                  <label htmlFor="remark">Remark <span>(optional)</span></label>
                  <textarea
                    id="remark"
                    name="remark"
                    value={formData.remark}
                    onChange={handleChange}
                    className="form-control quote-textarea"
                    placeholder="Add handling notes or special instructions"
                  ></textarea>
                </div>
              </div>

              <div className="quote-surface-footer">
                <button
                  className="quote-secondary-action"
                  type="button"
                  onClick={handleBack}
                >
                  <i className="fa fa-arrow-left"></i> Back
                </button>
                <button className="quote-primary-action" type="submit">
                  Review quote <i className="fa fa-arrow-right"></i>
                </button>
              </div>
            </form>
          </section>

          {loginModal && (
            <LoginModal
              show={loginModal}
              handleClose={closeLoginModal}
              mobile={formData.mobile}
            />
          )}
        </div>
      </main>
    </FrontendLayout>
  );
};

export default Qoute;
